import { T2LoadingService } from './../../../trip2-theme/components/t2-loading/t2-loading.service';
import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { ReservationService } from '../reservations.service';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { ViewAttachmentFileComponent } from '../../A2-utils/grid-components/view-attachment-file/view-attachment-file.component';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-trip-history-change',
  templateUrl: './trip-history-change.component.html',
  styleUrls: ['./trip-history-change.component.scss']
})
export class TripHistoryChangeComponent implements OnInit, OnDestroy {
  protected isMsgVisible = false;
  protected b64File: string;
  protected strSubstr: string;
  protected str: string;
  protected base64File: string;
  protected description: string = null;
  protected dataRervationFile: any;
  protected fileName: string;
  protected mimeType: string;
  protected readHistoryFilesValue: any;
  protected uploadHistoryEvent: any;
  protected grid: GridOptions;
  private observables: Subscription[] = [];
  public data: any;
  @Input() tripid: number;
  @Input() standingOrderId?: number;
  @ViewChild('attachment') attachmentBtn: ElementRef;
  @ViewChild('popContent') popContent: T2CardComponent;
  constructor(
    protected service: ReservationService,
    protected renderer: Renderer,
    protected showLoading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    const self = this;
    this.grid = <GridOptions>{
      enableFilter: true,
      enableSorting: true,
      enableColResize: true

    };
    this.grid.enableColResize = true;
    this.configureGrid();
  }

  ngOnInit() {
    if (this.tripid !== 0) {
      this.getHistory();
    }
    if (this.standingOrderId) {
      this.getHistorySO();
    }
  }

  /**
   * @description
   */
  public getHistory() {
    this.observables.push(
      this.service.getTripHistory(this.tripid).subscribe(
        data => {
          this.data = data;
          if (this.grid) {
            if (this.grid.api) {
              this.grid.api.setRowData(data);
              this.grid.api.refreshView();
            }
          }
        }
      ));
  }

  /**
   * @description
   */
  public getHistorySO() {
    this.observables.push(
    this.service.getHistorySO(this.standingOrderId).subscribe(
      data => {
        this.data = data;
        if (this.grid) {
          if (this.grid.api) {
            this.grid.api.setRowData(data);
            this.grid.api.refreshView();
          }
        }
      }
    ));
  }

  /**
   * METHODS TO UPLOAD FILES
   */
  uploadHistoryFile(event) {
    const target = event.target as HTMLInputElement;
    const files = target.files;

    if (!files.length) {
      return;
    }

    const file = files[0];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (this.isValidFileExtension(fileExtension)) {
      this.isMsgVisible = false;
      this.readHistoryFilesValue = file;
      this.uploadHistoryEvent = event;
      this.fileName = file.name;
      this.mimeType = file.type;
      this.readFiles(file);
    } else {
      this.showInvalidFileAlert();
    }
  }

  private isValidFileExtension(ext: string | undefined): boolean {
    const img = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'];
    const doc = ['pdf', 'PDF'];
    return img.indexOf(ext) > -1 || doc.indexOf(ext) > -1;
  }

  private showInvalidFileAlert(): void {
    this.sweetAlertHelper.createCustomAlert({
      type: 'error',
      title: 'Format not allowed, use jpg, jpeg, png, or pdf formats',
      showConfirmButton: true,
      confirmButtonText: 'Ok',
    });
  }


  get existFile(): boolean {
    return !!this.base64File && !!this.description;
}

  saveReservFile(): void {
    if (this.base64File && this.description) {
      this.showLoading.show();
      this.isMsgVisible = false;
      this.str = this.base64File;
      this.strSubstr = this.str.slice(0, this.str.lastIndexOf(','));
      this.b64File = this.base64File.replace(this.strSubstr + ',', '');

      if (this.standingOrderId) {
        this.dataRervationFile = {
          'standingOrderId': this.standingOrderId,
          'attachement': this.b64File,
          'mimetype': this.mimeType,
          'attachementname': this.description
        };
        this.observables.push(
        this.service.putSOHistoryFile(this.dataRervationFile)
        .finally(() => this.showLoading.hiden())
        .subscribe(
          data => {
            this.getHistorySO();
            this.resetView();
          },
          err => {}
        ));
      } else {
        this.dataRervationFile = {
          'tripid': this.tripid,
          'attachement': this.b64File,
          'mimetype': this.mimeType,
          'attachementname': this.description
        };
        this.observables.push(
        this.service.putReservationHistoryFile(this.dataRervationFile)
        .finally(() => this.showLoading.hiden())
        .subscribe(
          data => {
            this.getHistory();
            this.resetView();
          },
          err => {}
        ));
      }
    } else {
      this.isMsgVisible = true;
    }
  }

  readFile(file, reader, callback) {
    reader.onload = () => {
      callback(reader.result);
      this.base64File = reader.result;

    };
    reader.readAsDataURL(file);
  }

  readFiles(files) {
    const reader = new FileReader();
    this.readFile(files, reader, (result) => {
      // this.historyFileSelected=result;
    });
  }

  private resetView() {
    this.description = null;
    this.base64File = null;
    this.description = '';
    this.fileName = '';
    this.b64File = null;
    this.uploadHistoryEvent.target.value = '';
    this.popContent.close();
  }

  /**
   * CONFIG GRID
   */

  private configureGrid() {
    this.grid.columnDefs = [{
      headerName: 'Date',
      field: 'date',
      colId: 'date',
      width: 80,
    },
      {
        headerName: 'Time',
        field: 'time',
        colId: 'consecutive',
        width: 80
      },
      {
        headerName: 'Description',
        field: 'description',
        colId: 'company',
        width: 380
      },
      {
        headerName: 'User',
        field: 'userprofile.fullname',
        colId: 'status',
        width: 110
      },
      {
        headerName: 'Type',
        field: 'userprofile.role.description',
        colId: 'payor',
        width: 60
      },
      {
        headerName: 'File',
        field: 'attachment',
        cellRendererFramework: ViewAttachmentFileComponent,
        colId: 'attachedFile',
        width: 30,
      }

    ];
  }

  public resizeGrid(grid) {
    grid.api.sizeColumnsToFit();
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip-history-change/trip-history-change.component.ts